import React, { useEffect, useState } from 'react';

import { Box, Typography, Button } from '@mui/material';
import useTranslation from '../components/customHooks/translations';
import GroupCard from '../components/GroupCard';
import { API } from '../services/amplifyCompat';
import { getAllGroupsForUser } from '../graphql/queries';
import { useNavigate } from 'react-router-dom';
import { useUserInfoContext } from '../hooks/use-user-info-context';
import { isTransientNetworkError } from '../utils/network-retry';

const MyGroups = () => {
  const navigate = useNavigate();
  const { user } = useUserInfoContext();
  const [userGroups, setUserGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      getGroups();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const translation = useTranslation();
  const getGroups = async () => {
    setLoading(true);
    try {
      const res = await API.graphql({
        query: getAllGroupsForUser,
        variables: { user_id: user.user_id },
        suppressTransientNetworkErrorCapture: true,
      });
      setUserGroups(res?.data?.getAllGroupsForUser ?? []);
    } catch (error) {
      setUserGroups([]);

      if (isTransientNetworkError(error)) {
        return;
      }
    } finally {
      setLoading(false);
    }
  };
  const renderGroupCards = () => {
    if (loading) {
      return null;
    }
    if (userGroups.length > 0) {
      return userGroups.map((group, index) => (
        <GroupCard key={group.group_id ?? index} group={group} user={user} />
      ));
    }
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: '2em' }}>
        <Typography variant="subtitle2">{translation.noMyGroups}</Typography>
      </Box>
    );
  };
  return (
    <>
      <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
        <Typography variant="h1">{translation.myGroups}</Typography>
        <Box
          component="div"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            m: '4em 0 1.25em',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: '1em' },
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              navigate('/create-group');
            }}
          >
            {translation.createNewGroup}
          </Button>
        </Box>
        {renderGroupCards()}
      </Box>
    </>
  );
};

export default MyGroups;
